import { styled } from '@mui/material/styles';

import arrowBack from 'assets/icons/arrow-left.svg';
import { SharedProgressStyles, SharedSimpleHeaderStyles } from '../sharedStyles';

const BackButton = ({ hasBackButton }) =>
  !hasBackButton &&
  `   
      display: flex;
      justify-content: center;
      
     svg {
         margin-right: 0;
      }
    `;

export const StyledHeader = styled('header')(
  ({ theme, hasBackButton, progress, $isDRSmileInactive }) => `
  
  ${SharedSimpleHeaderStyles({ theme, $isDRSmileInactive })};
  ${SharedProgressStyles({ theme, progress })}
   position: fixed;
   justify-content: space-between;
 
    svg {
      margin-right: 60px; /* set margin to width of arrow button to centre logo */
   }


    button {
      border: none;
      margin-left:${theme.DS_spacing(['xs'])};
      padding: ${theme.DS_spacing(['xs'])};
  
      :after {
        content: '';
        background-image: url(${arrowBack});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${theme.DS_spacing(['xxsx'])};
        width: ${theme.DS_spacing(['xxsx'])};
        height: ${theme.DS_spacing(['xxsx'])};
        display: block;
      }
    }
  
   ${theme.breakpoints.up('lg')} {
  
    svg {
      margin-right: 110px; /* set margin to width of arrow button to centre logo */
    }
    
    button {
       padding: ${theme.DS_spacing(['md'])};
       margin-left:${theme.DS_spacing(['xl'])};
        :after {
          width: ${theme.DS_spacing(['sm'])};
          height: ${theme.DS_spacing(['sm'])};
        }
      }
    }

${BackButton({ hasBackButton })}

`,
);
